<template>
  <div
    :id="'item_' + item.index"
    class="c-virtual-list__row"
    :class="{ 'is-checked': isChecked }"
    ref="row"
    @animationend="animationend"
    @click.prevent="click"
  >
    <div class="c-virtual-list__col check">
      <Checkbox
        :id="'check_' + item.index"
        name="keywords[]"
        :value="item"
        :checked="checked"
        ref="checkbox"
        @change="change"
      />
    </div>
    <div class="c-virtual-list__col keyword">
      <EllipsisPopover :clamp="2" placement="right-end">
        {{ item.keyword }}
      </EllipsisPopover>
    </div>
    <div class="c-virtual-list__col rank c-text--right">
      {{ item.rank | roundFloatingPointNumber(1) }}
    </div>
    <div v-if="isInflux" class="c-virtual-list__col searchVolume c-text--right">
      {{ item.searchVolume | separateNumber | truncateNull }}
    </div>
    <div class="c-virtual-list__col impressions c-text--right">
      {{ item.impressions | separateNumber | nullToZero }}
    </div>
    <div class="c-virtual-list__col ctr c-text--right">
      {{ item.ctr | roundFloatingPointNumber(2) }}%
    </div>
    <div class="c-virtual-list__col influx c-text--right">
      {{ item.influx | separateNumber | nullToZero }}
    </div>
    <div v-if="isConversionDirect" class="c-virtual-list__col cv c-text--right">
      {{ item.directConversion | separateNumber | nullToZero }}
    </div>
    <div
      v-if="isConversionAssisted"
      class="c-virtual-list__col cv c-text--right"
    >
      {{ item.assistedConversion | separateNumber | nullToZero }}
    </div>
    <div
      v-if="isConversionDirect"
      class="c-virtual-list__col cvr c-text--right"
    >
      {{ item.directConversionRate | roundFloatingPointNumber(2) }}%
    </div>
    <div
      v-if="isConversionAssisted"
      class="c-virtual-list__col cvr c-text--right"
    >
      {{ item.assistedConversionRate | roundFloatingPointNumber(2) }}%
    </div>
    <div class="c-virtual-list__col url">
      <EllipsisPopover :clamp="2" placement="left-end">
        <a :href="item.url" target="_blank" class="c-link--blank" @click.stop>
          {{ url }}
        </a>
        <template slot="popover">
          <a :href="item.url" target="_blank" @click.stop>
            {{ url }}
          </a>
        </template>
      </EllipsisPopover>
    </div>
    <div v-if="isInflux" class="c-virtual-list__col title">
      <EllipsisPopover v-if="item.title" :clamp="1" placement="left-end">
        {{ item.title }}
      </EllipsisPopover>
      <template v-else>
        データがありません（原因は<a
          href="https://support.searchwrite.jp/hc/ja/articles/360004428195"
          target="_blank"
          class="c-link--blank"
          @click.stop
          >こちら</a
        >）
      </template>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import EllipsisPopover from '@/components/EllipsisPopover';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    conversionType: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Checkbox,
    EllipsisPopover
  },
  computed: {
    url() {
      return this.$options.filters.removeDomain(
        this.item.url,
        this.project.siteUrl
      );
    },
    isChecked() {
      return this.checked.some(check => check.id === this.item.id);
    },
    isConversion() {
      return this.dataType === 'conversion';
    },
    isConversionAssisted() {
      return this.isConversion && this.conversionType === 'assisted';
    },
    isConversionDirect() {
      return this.isConversion && this.conversionType === 'direct';
    },
    isInflux() {
      return this.dataType === 'influx';
    }
  },
  methods: {
    animationend() {
      this.$el.classList.remove('is-blink');
    },
    change(checked) {
      this.$emit('check', checked);
    },
    click() {
      this.$refs.checkbox.change();
    }
  }
};
</script>
